
// @deprecated - use TrackerEvents instead
export enum TrackerEvents {
  CourseResourcesView = 'mm_ga4_course_resources_view',
}